class Pin {
    /**
     * Notification Functions (SweetAlerts)
     */

    /**
     * Show a loading sweet alert
     * @param {string} title
     */
    ShowLoading(title = "Loading...") {
        Swal.fire({
            title,
            html: '<div class="d-flex justify-content-center"><div style="display: block" class="lds-circle"></div></div>',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
        });
    }

    /**
     * Hides the loading sweet alert but can also hide any sweet alert
     */
    HideLoading() {
        Swal.close();
    }

    /**
     * Pops an server error sweet alert
     * @param {array|null} response 
     */
    ServerError(response) {
        Swal.fire({
            title: "Error",
            html: `${response.Error?.Message || 'No message'} (${response.Error?.Code || 0})`,
            type: "error"
        });
    }

    /**
     * Pops an network error
     */
    NetworkError() {
        Swal.fire({
            title: "Network Error",
            html: "Check your network or contact support@altcointrader.co.za",
            type: "error"
        });
    }

    /**
     * Constructor
     */
    constructor(modal = false) {

        if (modal) {
            $("#userActPinModal").modal("show");

            $(document).on('click', ".cancelActPin", function () {
                $(document).on('click', function (e) {
                    const isOutsideMainNav = !$(e.target).closest('#main-nav').length;
                    const isModalOpen = $('.modal.show').length > 0;

                    if (isOutsideMainNav && !isModalOpen) {
                        e.preventDefault();
                        $('#userActPinModal').modal('show');
                    }
                });
            });
        }

        const self = this;
        this.$pinForm = $("#pinForm");
        this.$pinOld = $("[name=user_pin_old]");
        this.$pinNew = $("[name=user_pin_new]");
        this.$pinRepeat = $("[name=user_pin_repeat]");
        this.pinLengths = [4];
        this.updateTimer;

        this.pinLengths.forEach(length => {
            this.setupPinInput(`pin${length}-wrapper`, `pin${length}-confirm-wrapper`);
            this.setupPinInput(`pin${length}-confirm-wrapper`);
        });
        this.setupPinInput('pin-old-wrapper');

        document.querySelectorAll('#pinTab a[data-toggle="tab"]').forEach(link => {
            link.addEventListener('click', function () {
                this.resetPinFields(this.id === "pin4-tab" ? 6 : 4);
            });
        });

        this.$pinForm.on("click", ".processPin", function (e) {
            e.preventDefault();
            if (!self.validateForm()) return;
            self.ShowLoading();

            $.ajax({
                url: "/services/user/setup-pin.php",
                method: "POST",
                data: {
                    user_pin_old: self.$pinOld.val(),
                    user_pin_new: self.$pinNew.val(),
                    user_pin_repeat: self.$pinRepeat.val()
                },
                success: (response) => self.handleSetupResponse(response),
                error: self.NetworkError
            });
        });


    }

    /**
     * Public Functions
     */

    debounceUpdateHiddenInputs() {
        clearTimeout(this.updateTimer);
        this.updateTimer = setTimeout(() => this.updateUnifiedHiddenInputs(), 50);
    }

    collectPin(wrapper) {
        if (!wrapper) return '';
        return Array.from(wrapper.querySelectorAll('.pin-input')).map(input => input.dataset.value || '').join('');
    }

    setupPinInput(wrapperId, nextWrapperId = null) {
        const wrapper = document.getElementById(wrapperId);
        if (!wrapper) return;

        const inputs = wrapper.querySelectorAll('.pin-input');

        inputs.forEach((input, index) => {
            input.setAttribute("type", "tel");
            input.setAttribute("inputmode", "numeric");
            input.setAttribute("maxlength", "1");
            input.dataset.value = "";

            input.addEventListener('input', (e) => {
                const val = e.target.value.replace(/[^0-9]/g, '').slice(-1);
                input.dataset.value = val;
                input.value = val ? '*' : '';

                if (val && index < inputs.length - 1) {
                    setTimeout(() => inputs[index + 1].focus(), 10);
                } else if (val && nextWrapperId) {
                    const nextWrapper = document.getElementById(nextWrapperId);
                    const nextInputs = nextWrapper?.querySelectorAll('.pin-input');
                    if (nextInputs && nextInputs.length > 0) {
                        setTimeout(() => nextInputs[0].focus(), 10);
                    }
                }

                this.debounceUpdateHiddenInputs();
            });

            // Allow backspace to move to previous input
            input.addEventListener('keydown', (e) => {
                if (e.key === 'Backspace' && input.value === '' && index > 0) {
                    inputs[index - 1].focus();
                }
            });

            input.addEventListener('focus', () => {
                // Always set cursor to the end when focused
                requestAnimationFrame(() => {
                    input.setSelectionRange(1, 1);
                });
            });

            // Prevent cursor from being placed anywhere except at the end
            input.addEventListener('mousedown', (e) => {
                e.preventDefault(); // block default mouse placement
                input.focus(); // force focus
                requestAnimationFrame(() => {
                    input.setSelectionRange(1, 1);
                });
            });

        });
    }

    resetPinFields(length) {
        ['', '-confirm'].forEach(suffix => {
            const wrapper = document.getElementById(`pin${length}${suffix}-wrapper`);
            if (wrapper) {
                wrapper.querySelectorAll('.pin-input').forEach(input => {
                    input.value = '';
                    input.dataset.value = '';
                });
            }
        });
        this.debounceUpdateHiddenInputs();
    }

    updateUnifiedHiddenInputs() {
        const is4Digit = document.querySelector('#pinTab .nav-link.active')?.id === "pin4-tab";
        const length = 4 // is4Digit ? 4 : 6;

        document.getElementById('user_pin_old').value = this.collectPin(document.getElementById('pin-old-wrapper'));
        document.getElementById('user_pin_new').value = this.collectPin(document.getElementById(`pin${length}-wrapper`));
        document.getElementById('user_pin_repeat').value = this.collectPin(document.getElementById(`pin${length}-confirm-wrapper`));
    }

    validateForm() {
        const newPin = this.$pinNew.val().trim();
        const repeatPin = this.$pinRepeat.val().trim();
        const pinLength = newPin.length;

        console.log(newPin);

        if (![4, 6].includes(pinLength)) {
            Swal.fire({
                type: "error",
                title: "Invalid PIN Length",
                text: "PIN must be 4 digits."
            });
            return false;
        }

        if (newPin !== repeatPin) {
            Swal.fire({
                type: "error",
                title: "PINs don't match",
                text: "The PINs you entered do not match."
            });
            return false;
        }

        return true;
    }

    /**
     * Private Functions
     */

    handleSetupResponse(response) {
        this.HideLoading();
        if (response.Error?.Code === 0) {
            switch (response.Data.method) {
                case "2FA": this.authorize2FA(); break;
                case "email": this.authorizeEmail(); break;
            }
        } else {
            this.ServerError(response);
        }
    }

    openAuthModal(url, modalId, inputSelector, method) {
        $.ajax({
            url,
            method: 'POST',
            success: (data) => {
                $('body').append(data);
                $("#userActPinModal").modal('hide');
                const $modal = $(modalId);
                $modal.modal('show');

                const $form = $modal.find('form');
                $form.off('submit').on('submit', (e) => {
                    e.preventDefault();
                    this.ShowLoading("Confirming PIN");

                    const otp = $(inputSelector).val().trim();

                    $.ajax({
                        url: '/services/user/activate-pin.php',
                        method: 'POST',
                        data: { otp, method },
                        success: (response) => {
                            if (response.Error?.Code === 0) {
                                Swal.fire({
                                    type: 'success',
                                    title: 'Verified',
                                    text: 'ACT Pin is successfully activated.'
                                }).then(() => window.location.reload());
                            } else {
                                this.ServerError(response);
                            }
                        },
                        error: this.NetworkError
                    });
                });

                const $attempts = $modal.find('#attempts_remaining');

                const $resendBtn = $modal.find('.resend-otp');
                $resendBtn.off('click').on('click', () => {
                    this.ShowLoading("Sending OTP");
                    $.ajax({
                        url: '/services/user/resend-pin-otp.php',
                        method: 'POST',
                        data: { method },
                        success: (data) => {
                            Swal.fire({
                                type: 'info',
                                title: 'OTP Sent',
                                text: 'A verification code has been sent.'
                            });
                            $attempts.text(5 - data.Data?.attempts);
                        },
                        error: this.NetworkError
                    });
                });
            },
            error: this.NetworkError
        });
    }

    authorize2FA() {
        this.HideLoading();
        this.openAuthModal('/includes/modal/user/pin/twofa.php', '#twoFAActPINmodal', '#user_code', '2FA');
    }

    authorizeEmail() {
        this.HideLoading();
        this.openAuthModal('/includes/modal/user/pin/email.php', '#emailActPINmodal', '#email-otp-code', 'email');
    }
}